import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const GetMailFromPreselectedInfluencer = (id_ean: string) => {
  return apiInstance.get(ApiPathConfig.EXPORT_MAIL_CHRONIQUEUR(id_ean))
}

export default GetMailFromPreselectedInfluencer
